module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Day":"Day","Month":"Month","Ordinarily":"Ordinarily","DayOfMonthRepeat":"Day of month repeat","TimeOfTheMonthRepeat":"Time of the month repeat"},"vi":{"Day":"Ngày","Month":"Tháng","Ordinarily":"Thứ tự","DayOfMonthRepeat":"Vào ngày","TimeOfTheMonthRepeat":"Vào thời điểm"}}')
  delete Component.options._Ctor
}
